"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pdf = exports.getZip = exports.getCSV = exports.formData = exports.docx = exports.default = exports.csv = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cookie = _interopRequireDefault(require("cookie"));

var _createRedirectHandler = _interopRequireDefault(require("./create-redirect-handler"));

var _jiff = _interopRequireDefault(require("jiff"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var generateAuthHeader = function generateAuthHeader() {
  var bearerToken = _cookie.default.parse(document.cookie).bearer;

  if (bearerToken) {
    return {
      Authentication: "Bearer ".concat(bearerToken)
    };
  }
};

var getHeader = function getHeader(headers) {
  return _objectSpread(_objectSpread({}, generateAuthHeader()), headers);
};

var jsonHandler = function jsonHandler(result) {
  if (result.ok && result.status >= 200 && result.status < 400) {
    if (result.status !== 204) {
      return result.json();
    }

    return result;
  }

  return Promise.reject(result);
};

var arrayBufferHandler = function arrayBufferHandler(result) {
  if (result.ok && result.status >= 200 && result.status < 400) {
    return result.arrayBuffer();
  }

  return Promise.reject(result);
};

var wrapped = function wrapped(promise) {
  return new Promise(function (resolve, reject) {
    promise.then(resolve).catch(reject);
  });
};

var getZip = function getZip(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return wrapped(fetch(url, {
    method: 'GET',
    headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
      'Content-Type': 'application/zip'
    })
  })).then(arrayBufferHandler).then(function (data) {
    return new Blob([data], {
      type: 'application/zip'
    });
  });
};

exports.getZip = getZip;

var getCSV = function getCSV(url, options) {
  return csv.get(url, options);
};

exports.getCSV = getCSV;
var csv = {
  get: function get(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return wrapped(fetch(url, {
      method: 'GET',
      headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
        'Accept': 'text/csv'
      })
    })).then(function (result) {
      if (result.ok && result.status >= 200 && result.status < 400) {
        return result.text();
      }

      return Promise.reject(result);
    });
  },
  post: function post(url, payload) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return wrapped(fetch(url, {
      method: 'POST',
      headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
        'Accept': 'text/csv'
      }),
      body: JSON.stringify(payload)
    })).then(function (result) {
      if (result.ok && result.status >= 200 && result.status < 400) {
        return result.text();
      }

      return Promise.reject(result);
    });
  }
};
exports.csv = csv;
var formData = {
  post: function post(url, body) {
    return wrapped(fetch(url, {
      method: 'POST',
      headers: _objectSpread(_objectSpread({}, generateAuthHeader()), {}, {
        'Accept': 'application/json'
      }),
      body: body
    })).then(jsonHandler);
  }
};
exports.formData = formData;
var pdf = {
  get: function get(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return wrapped(fetch(url, {
      method: 'GET',
      headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
        'Accept': 'application/pdf'
      })
    })).then(arrayBufferHandler);
  },
  post: function post(url, domain) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return wrapped(fetch(url, {
      method: 'POST',
      body: JSON.stringify(domain),
      headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
        'Accept': 'application/pdf'
      })
    })).then(arrayBufferHandler);
  }
};
exports.pdf = pdf;
var docx = {
  get: function get(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return wrapped(fetch(url, {
      method: 'GET',
      headers: _objectSpread(_objectSpread({}, getHeader(options.headers)), {}, {
        'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      })
    })).then(arrayBufferHandler);
  }
};
exports.docx = docx;

var _default = function _default(unauthorizedFallbackUrlFn) {
  var redirectHandler = (0, _createRedirectHandler.default)(unauthorizedFallbackUrlFn);
  return {
    get: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return wrapped(fetch(url, {
        method: 'GET',
        headers: getHeader(options.headers)
      })).then(redirectHandler).then(jsonHandler);
    },
    post: function post(url, domain) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return wrapped(fetch(url, {
        method: 'POST',
        body: JSON.stringify(domain),
        headers: getHeader(options.headers)
      })).then(redirectHandler).then(jsonHandler);
    },
    put: function put(url, domain) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return wrapped(fetch(url, {
        method: 'PUT',
        body: JSON.stringify(domain),
        headers: getHeader(options.headers)
      })).then(redirectHandler).then(jsonHandler);
    },
    delete: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return wrapped(fetch(url, {
        method: 'DELETE',
        headers: getHeader(options.headers)
      })).then(redirectHandler).then(jsonHandler);
    },
    patch: function patch(url) {
      for (var _len = arguments.length, patchDetails = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        patchDetails[_key - 1] = arguments[_key];
      }

      var patch = _jiff.default.diff.apply(_jiff.default, patchDetails);

      return wrapped(fetch(url, {
        method: 'PATCH',
        headers: _objectSpread({}, generateAuthHeader()),
        body: JSON.stringify(patch)
      })).then(redirectHandler).then(jsonHandler);
    },
    legacy: {
      patchWithoutDiff: function patchWithoutDiff(url, updatedObj) {
        return wrapped(fetch(url, {
          method: 'PATCH',
          headers: _objectSpread({}, generateAuthHeader()),
          body: JSON.stringify(updatedObj)
        })).then(redirectHandler).then(jsonHandler);
      }
    }
  };
};

exports.default = _default;